import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export interface ISetIdParam {
    id: number | null;
}
export interface ISetBaseIdParam {
    baseId: number | null;
}

export const setIdAction = actionCreator<ISetIdParam>('setIdAction');
export const setBaseIdAction = actionCreator<ISetBaseIdParam>(
    'setBaseIdAction',
);
